import axios from 'axios'
import url from '@/url'
export const state = {
    marketAdmins:[]
}
export const actions = {
     createMarketAdmin({commit},data) {
         return new Promise((resolve,reject)=> {
             axios.post(`${url()}/admin/create`,data)
                .then(response => {
                    if(response) {
                        const admin = response.data.admin
                        commit('add_admin',admin)
                     }
                     resolve(response)
                }).catch(err => {
                    reject(err)
                })
         })
       },

    getAllMarketAdmins({commit}){
       return new Promise((resolve, reject) => {
           axios.get(`${url()}/admins`)
            .then(response => {
                if(response) {
                    console.log('response', response)
                    
                }
                resolve(response)
            }).catch(err => {
                console.log(err)
                reject(err)
            })
       })
    },
}

export const mutations = {
    add_admin(state,admin) {
        state.marketAdmins.push(admin)
    }
}
